import { axios } from '@/utils/request'

// 获取优惠券列表
export function getCouponList(params) {
  return axios({
    url: '/distribution/couponItem',
    method: 'GET',
    params: params
  })
}

// 优惠券使用记录导出
export function couponExport(data) {
  return axios({
    url: '/distribution/couponItem/exportCounponLog',
    method: 'POST',
    data: data
  })
}
// 临时优惠券提醒
export function getCouponReminder(params) {
  return axios({
    url: '/distribution/tempCouponReminder',
    method: 'GET',
    params: params
  })
}
// 更新优惠券提醒为已阅读
export function putCouponReminder(id) {
  return axios({
    url: '/distribution/tempCouponReminder/' + id,
    method: 'GET'
  })
}
